import axios from "axios";
import { encryptRequestData } from "../utils/request-encryptor.js";

let timeoutCallbacks = null;

export const setTimeoutResetCallback = (callbacks) => {
    timeoutCallbacks = callbacks;
};

axios.interceptors.request.use(
    async (config) => {
        // Pause session timeout during API calls
        if (timeoutCallbacks?.pauseTimeout) {
            timeoutCallbacks.pauseTimeout();
        }

        const token = sessionStorage.getItem("Token");
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        // Encrypt PK/SK fields in request data
        if (config.data && typeof config.data === 'object' && !(config.data instanceof File)) {
            config.data = await encryptRequestData(config.data);
        }
        return config;
    },

    (error) => {
        return Promise.reject(error instanceof Error ? error : new Error(error));
    }
);

axios.interceptors.response.use(
    (response) => {
        // Resume session timeout after API completes
        if (timeoutCallbacks?.resumeTimeout) {
            timeoutCallbacks.resumeTimeout();
        }
        return response;
    },
    (error) => {
        // Resume session timeout after API error
        if (timeoutCallbacks?.resumeTimeout) {
            timeoutCallbacks.resumeTimeout();
        }
        
        // Handle 401 Unauthorized - auto logout after authentication complete
        if (error?.response?.status === 401) {
            const url = error?.config?.url || '';
            // Don't auto-logout during authentication flow
            if (!url.includes('/authenticate') && !url.includes('/verifycode')) {
                // Check if user has completed authentication
                const hasUser = sessionStorage.getItem('User');
                const hasDept = sessionStorage.getItem('DeptId');
                if (hasUser && hasDept) {
                    sessionStorage.clear();
                    sessionStorage.setItem("isLoggingOut", "true");
                    window.location.reload();
                    return Promise.reject("Session expired - please login again");
                }
            }
        }
        
        if (error?.response?.data?.Message) {
            return Promise.reject(error.response.data.Message);
        }
        return Promise.reject("Unable to process request");
    }
);